module.exports = __webpack_public_path__ + "static/media/unread.66cfab81.png";